import React from 'react';
import dayjs from 'dayjs';

const EventModal = ({ date, events, onClose }) => {
  const sortedEvents = events.sort((a, b) => 
    dayjs(`${a.date} ${a.time}`).isBefore(dayjs(`${b.date} ${b.time}`)) ? -1 : 1
  );

  const hasTimeConflict = (events) => {
    if (events.length <= 1) return false;
    
    for (let i = 0; i < events.length; i++) {
      for (let j = i + 1; j < events.length; j++) {
        const event1Start = dayjs(`${events[i].date} ${events[i].time}`);
        const event1End = event1Start.add(events[i].duration, 'hour');
        const event2Start = dayjs(`${events[j].date} ${events[j].time}`);
        const event2End = event2Start.add(events[j].duration, 'hour');
        
        if (event1Start.isBefore(event2End) && event2Start.isBefore(event1End)) {
          return true;
        }
      }
    }
    return false;
  };

  const getEventEndTime = (event) => {
    const startTime = dayjs(`${event.date} ${event.time}`);
    return startTime.add(event.duration, 'hour').format('h:mm A');
  };

  const conflictExists = hasTimeConflict(events);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-96 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-xl font-bold">
                {date.format('MMMM D, YYYY')}
              </h3>
              <p className="text-blue-100 text-sm">
                {date.format('dddd')} • {events.length} event{events.length !== 1 ? 's' : ''}
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-200"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {conflictExists && (
            <div className="mt-3 bg-red-500 bg-opacity-20 border border-red-300 rounded-lg p-3">
              <div className="flex items-center">
                <svg className="w-5 h-5 text-red-300 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <span className="text-sm font-medium text-red-100">
                  Time conflicts detected between events
                </span>
              </div>
            </div>
          )}
        </div>
        
        {/* Events list */}
        <div className="p-6 max-h-80 overflow-y-auto">
          <div className="space-y-4">
            {sortedEvents.map((event, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-4 border-l-4 border-blue-500 hover:bg-gray-100 transition-colors duration-200"
              >
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-semibold text-gray-800 text-lg">
                    {event.title}
                  </h4>
                  <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                    {event.duration}h
                  </span>
                </div>
                
                <div className="flex items-center text-gray-600 text-sm mb-2">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>
                    {dayjs(`${event.date} ${event.time}`).format('h:mm A')} - {getEventEndTime(event)}
                  </span>
                </div>
                
                {event.description && (
                  <p className="text-gray-600 text-sm">
                    {event.description}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventModal;